(() => {
  'use strict';

  const normalize = value => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const CARD_SELECTOR = '.product-card, .product-card--overlay, .card-product, .card-product-list, [class*="product-card"]';

  function hideSafely(node) {
    if (!node) return;
    if (node.querySelector?.('img, picture')) return;
    node.style.setProperty('display', 'none', 'important');
    node.setAttribute('aria-hidden', 'true');
  }

  function cleanCard(card) {
    if (!card || card.dataset.ksSizeCleaned === '1') return;

    const controls = card.querySelectorAll('select[name*="Shirt Size"], input[name*="Shirt Size"], textarea[name*="Shirt Size"], select[name*="shirt size"], input[name*="shirt size"], textarea[name*="shirt size"]');
    controls.forEach(control => {
      control.required = false;
      control.disabled = true;
      const wrapper = control.closest('[data-custom-property], .form-field, .product__block--line_item_property');
      if (wrapper && !wrapper.querySelector('img, picture')) hideSafely(wrapper);
      else control.style.setProperty('display', 'none', 'important');
    });

    card.querySelectorAll('label').forEach(label => {
      if (!normalize(label.textContent).includes('shirt size')) return;
      const wrapper = label.closest('[data-custom-property], .form-field, .product__block--line_item_property');
      if (wrapper && !wrapper.querySelector('img, picture')) hideSafely(wrapper);
      else hideSafely(label);
    });

    card.querySelectorAll('p, small, span, div').forEach(el => {
      if (normalize(el.textContent) !== 'required for this order.') return;
      if (el.querySelector('img, picture, a, button, input, select, textarea')) return;
      hideSafely(el);
    });

    card.dataset.ksSizeCleaned = '1';
  }

  function clean() {
    document.querySelectorAll(CARD_SELECTOR).forEach(cleanCard);
  }

  function start() {
    clean();
    const observer = new MutationObserver(() => {
      document.querySelectorAll(CARD_SELECTOR).forEach(card => {
        if (card.querySelector('select[name*="Shirt Size"], input[name*="Shirt Size"], textarea[name*="Shirt Size"], label')) {
          card.dataset.ksSizeCleaned = '';
          cleanCard(card);
        }
      });
    });
    observer.observe(document.body, {childList:true, subtree:true});
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start, {once:true}) : start();
})();
